export const CLASSIFICACAO_FISCAL_OPCOES = [
  { value: 'SERVICO', label: 'Serviço' },
  { value: 'PRODUTO', label: 'Produto' },
  { value: 'COMISSAO', label: 'Comissão' },
]

export const MULTA_TIPO_OPCOES = [
  { value: 'FIXO', label: 'Fixo' },
  { value: 'PORCENTAGEM', label: 'Porcentagem' },
]

export function opcaoClassificacaoFiscal(valor) {
  if (valor == null || valor === '') {
    return null
  }
  const v = String(valor).toUpperCase()
  return CLASSIFICACAO_FISCAL_OPCOES.find((o) => o.value === v) ?? null
}

export function opcaoMultaTipo(valor) {
  if (valor == null || valor === '') {
    return { value: 'FIXO', label: 'Fixo' }
  }
  const v = String(valor).toUpperCase()
  return MULTA_TIPO_OPCOES.find((o) => o.value === v) ?? { value: 'FIXO', label: 'Fixo' }
}
